
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-session-warning-dialog',
  //standalone: true,
  //imports: [NgIf],
  template: `
    
  

  <div class="custom-modal" *ngIf="isOpen">
  <div class="modal-content">
    <h2>Session Timeout Warning</h2>
    <p *ngIf="countdown > 0">Your session will expire in {{ countdown }} seconds.</p>
    <p>Would you like to increase session?</p>
    <div style="width:200px;float:right">
    <button (click)="stay.emit()">Yes</button>
    <button (click)="logout.emit()">No</button>
    </div>
  </div>
</div>
`,
styles:[`
.custom-modal {
    z-index:998 !important;
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

}
.modal-content {
    z-index:999 !important;
background: #fff;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);
  
}



`]
})
export class SessionWarningDialogComponent {


  @Input() isOpen = false;
  @Input()countdown = 0;
   @Output() stay = new EventEmitter<void>();
   @Output() logout = new EventEmitter<void>();

}

